import React, { Component } from "react";

const ChipItem = ({
  key,
  number,
  onClick,
  isActive = false,
  isWin = false,
}) => {
  return (
    <div
      key={key}
      className={`chip-item ${isActive ? "active" : ""} ${isWin ? "win" : ""}`}
      onClick={() => onClick(number)}
    >
      <div className="content">
        <span>{number}</span>
      </div>
    </div>
  );
};
export default ChipItem;
